import React from "react";
import ReactDOM from "react-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

export const UserConfirmation = (message, callback) => {
   const container = document.createElement("div");
   container.setAttribute("custom-confirmation-navigation", "");
   document.body.appendChild(container);
const closeModal = (callbackState) => {
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
      callback(callbackState);
   };

   ReactDOM.render(
 
    confirmAlert({
        customUI: ({ onClose }) => {
            return (
              <div className="amex-confirm-alert amex-content-alert">
               
                <p className="amx-strong"></p>
                <p>It looks like you might have some unsaved  
                                            changes! Are you sure you want to continue?</p>
                <button
                  onClick={() => {
                    onClose();
                    closeModal(true);
                   
                  }}
                >
                  {"Yes"}
                </button>
                <button
                  onClick={() => {
                    onClose();
                    closeModal(false);
                    
                  }}
                >
                  {"No"}
                </button>
              </div>
            );
        },
    }),
   container
  );
};
